module.exports = __webpack_public_path__ + "img/googleplay-bg.3a3c3cb3.svg";